export enum OrientationTypeEnum {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}
